<template>
  <div>
    <b-container class="wide">
      <b-row class="no-margin-left ml-3 mt-5">
        <b-button
            class="mb-4"
            variant="outline-primary"
            @click="goToShelfTypes"
        >
          <b-icon icon="arrow-left" class="mr-2" />
          {{ $t('links.admin.go_back') }}
        </b-button>
      </b-row>
      <b-row class="no-margin-left">
        <b-card-group deck>
          <b-col
            cols="auto"
            v-for="(shelfPeriodPrice, key) in shelfPeriodPricesWithDiscount"
            :key="key"
          >
            <b-card
              header-class="text-center font-weight-bold"
              body-class="text-center"
              class="mb-5 mr-2 booking-period-card"
            >
              <!-- Card Header: booking period label + badge if discount active -->
              <template #header>
                <div class="d-flex align-items-center justify-content-center">
                  <h5 class="mb-0 mr-2">
                    {{ bookingPeriodLabel(shelfPeriodPrice.bookingPeriod) }}
                  </h5>
                  <b-badge
                    v-if="shelfPeriodPrice.discountedPrice"
                    variant="danger"
                    class="d-inline-flex align-items-center"
                  >
                    <b-icon icon="award-fill" class="mr-1" />
                    {{ $t("table.shelf_types.discount_title") }}
                  </b-badge>
                </div>
              </template>

              <!-- Price block: discounted or original -->
              <div class="mb-2">
                <span v-if="shelfPeriodPrice.discountedPrice">
                  <span class="text-danger font-weight-bold h4">
                    {{ formatNumber(shelfPeriodPrice.discountedPrice, { precision: 2, marketCountry: market?.supportCountry?.code }) }} {{ market.currencyCode }}
                    <small class="text-muted">(-{{ shelfPeriodPrice.discountPercent }}%)</small>
                  </span>
                  <br />
                  <small class="text-muted" style="text-decoration: line-through;">
                    {{ formatNumber(shelfPeriodPrice.originalPrice, { precision: 2, marketCountry: market?.supportCountry?.code }) }} {{ market.currencyCode }}
                  </small>
                </span>
                <span v-else class="font-weight-bold h4">
                  {{ formatNumber(shelfPeriodPrice.originalPrice, { precision: 2, marketCountry: market?.supportCountry?.code }) }} {{ market.currencyCode }}
                </span>
              </div>

              <!-- Discount validity info -->
              <small
                v-if="shelfPeriodPrice.discountedPrice && shelfPeriodPrice.discountValidTo"
                class="discount-info d-block mb-2"
              >
                {{ $t("table.shelf_types.discount_active_text", { date: formatDate(shelfPeriodPrice.discountValidTo, market?.supportCountry?.code, adminMarket?.timezone) }) }}
              </small>

              <!-- Action button -->
              <template #footer>
                <div class="d-flex justify-content-center">
                  <b-button
                    size="sm"
                    class="mr-2"
                    v-b-tooltip.hover
                    variant="success"
                    @click="selectShelfBookingPrice(shelfPeriodPrice)"
                  >
                    {{ $t('table.shelf_types.button_select') }}
                  </b-button>
                </div>
              </template>
            </b-card>
          </b-col>
        </b-card-group>
      </b-row>
    </b-container>
  </div>
</template>

<script>

  import BookingPeriodLabelMixin from "@base/mixins/BookingPeriodLabelMixin.vue";
  import Formatting from "@base/mixins/Formatting.vue";
  import DiscountUtilsMixin from "@base/mixins/DiscountUtilsMixin.vue";

  export default {
    name: 'SelectShelfPeriodPriceComponent',

    mixins: [ BookingPeriodLabelMixin, Formatting, DiscountUtilsMixin ],

    data () {
      return {
        loading: false,
      }
    },

    props: {
      fee: {
        type: String,
        required: true
      },
      shelfPeriodPrices: {
        type: Array,
        required: true,
      },
      market: {
        type: Object,
        required: true,
      },
    },

    computed: {
      shelfPeriodPricesWithDiscount() {
        return this.shelfPeriodPrices.map(p => {
          const originalPrice = parseFloat(p.price)
          const discountedPrice = this.computeDiscountedPrice(
            originalPrice,
            p.discountPercent,
            p.discountValidFrom,
            p.discountValidTo
          )

          return {
            ...p,
            originalPrice,
            discountedPrice
          }
        })
      }
    },

    methods: {
      selectShelfBookingPrice (shelfPeriodPriceObj) {
        this.$emit('shelfPeriodPriceSelected', shelfPeriodPriceObj)
      },

      goToShelfTypes () {
        this.$emit('backToShelfTypes')
      }
    }
  }
</script>

<style scoped>
  .card .card-header {
    background-color: transparent;
    border-color: transparent;
    padding: 0.6rem 0 0 0;
  }

  .card .card-body {
    padding: 0.5rem 0.75rem 0 0.75rem;
  }

  .booking-period-card {
    min-width: 23rem;
    min-height: 14rem;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s ease;
  }

  .booking-period-card:hover {
    transform: translateY(-4px);
  }

  .discount-info {
    font-size: 0.85rem;
    font-weight: 500;
    color: #28a745;
  }

</style>